import { usePostHttp } from "../../http.hook";
import type { IProposalSocials } from "./add-proposal-social.admin.http";

interface IBody {
  amount: number;
}

interface IResponse {
  campaignProposalSocial: IProposalSocials;
}

export function useAddFixedPayoutAmountToProposalAdminHttp() {
  return usePostHttp<IBody, IResponse>({
    path: "/admin/campaigns/proposals/:proposalId/socials/:proposalSocialId/fixed-payout-amount",
  });
}
